export default "__VITE_ASSET__FEPZX7tB__"